module.exports = __webpack_public_path__ + "static/img/005yanjing-2.3b163cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/005yanjing-2.png
// module id = 287/
// module chunks = 5